<template>
  <ul
    class="m-todo-column"
    @click="handleOpenApp"
  >
    <li
      class="u-tt"
      :title="info.msgTitle"
    >{{ info.msgTitle }}</li>
    <li class="u-status">{{ info.msgStatusStr }}</li>
    <li class="u-date">{{ info.msgCreateTime }}</li>
  </ul>
</template>

<script>
export default {
  props: {
    info: {
      default: () => {
        return {}
      },
      type: Object
    }
  },
  methods: {
    handleOpenApp () {
      let extendNoShow
      try {
        extendNoShow = JSON.parse(this.info.extendNoShow)
      } catch (error) {
        extendNoShow = false
      }
      if (extendNoShow && extendNoShow.targetMenuType) {
        this.handlerCrossMenu(extendNoShow.targetMenuType)
      } else {
        this.handlerGoToApp()
      }
    },
    handlerGoToApp () {
      let param
      if (this.info.menuCode) {
        param = {
          componentId: this.info.comId,
          componentMenuId: this.info.menuCode,
          msgType: 'tlnc',
          callback: { method: 'dealTlncMsg', argument: this.info },
          reload: false
        }
      } else {
        let extendNoShow = JSON.parse(this.info.extendNoShow)
        param = {
          url: extendNoShow.url,
          name: extendNoShow.name || this.$t('components.unknown_menu'),
          param: extendNoShow.param,
          msgType: 'tlnc'
        }
      }
      this.$emit('goto', param)
    },
    handlerCrossMenu (targetMenuType) {
      let params = {
        targetMenuType: targetMenuType,
        componentId: this.info.comId,
        componentMenuId: this.info.menuCode
      }
      this.$storage.set(`${this.info.comId}_${this.info.menuCode}_TLNC`, this.info)
      window.crossMenu(params)
    },
    setCookie (name, value) {
      let Days = 30
      let exp = new Date()
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 30)
      document.cookie = `${name}=${escape(value)};expires=${exp.toGMTString()}`
    }
  }
}
</script>

<style lang="less" scoped>
.m-todo-column {
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px;
  margin: 0;
  overflow: hidden;
  cursor: pointer;
  li {
    display: block;
    float: left;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.7);
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }
  .u-status {
    width: 90px;
    overflow: hidden;
  }
  .u-date {
    width: 80px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
    text-align: right;
    overflow: hidden;
  }
  .u-tt {
    width: calc(~"100% - 170px");
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.m-todo-column:hover {
  background: rgba(30, 127, 255, 0.08);
}
</style>
